import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { requestPasswordReset, resetPassword } from '../services/authService';
import './Login.css';

export default function ForgotPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const sendLink = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    try {
      const res = await requestPasswordReset(email);
      setMessage(res.message || 'Reset link sent.');
    } catch (err) {
      setError(err.message || 'Could not send reset link.');
    }
  };

  const doReset = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      const res = await resetPassword(token, password);
      setMessage(res.message || 'Password reset complete.');
    } catch (err) {
      setError(err.message || 'Could not reset password.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div>
            <p className="login-eyebrow">SFACO-CTG</p>
            <h1>{token ? 'Set new password' : 'Forgot password'}</h1>
            <p className="login-subtitle">
              {token
                ? 'Choose a new password for your account.'
                : 'Request a reset link by entering your email.'}
            </p>
          </div>
        </div>

        <form className="login-form" onSubmit={token ? doReset : sendLink}>
          {!token && (
            <label>
              Email address
              <input
                type="email"
                placeholder="you@alumni.org"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>
          )}

          {token && (
            <>
              <label>
                New password
                <input
                  type="password"
                  placeholder="New password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </label>
              <label>
                Confirm new password
                <input
                  type="password"
                  placeholder="Confirm password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </label>
            </>
          )}

          {error && <p className="login-error">{error}</p>}
          {message && <p className="register-message">{message}</p>}

          <button type="submit" className="login-submit">
            {token ? 'Reset password' : 'Send reset link'}
          </button>

          <p className="login-footnote">
            Remembered your password? <Link to="/login">Back to login</Link>
          </p>
          <Link className="back-home" to="/">Back to home</Link>
        </form>
      </div>
    </div>
  );
}
